import { render, staticRenderFns } from "./Precheck.vue?vue&type=template&id=612793ae&scoped=true&"
import script from "./Precheck.vue?vue&type=script&lang=js&"
export * from "./Precheck.vue?vue&type=script&lang=js&"
import style0 from "./Precheck.vue?vue&type=style&index=0&id=612793ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612793ae",
  null
  
)

export default component.exports